<template>
    <b-container>
        <b-row>
            <b-col cols="auto">
                <multiselect
                    v-model="defaultValue"
                    :options="actions"
                    track-by="name"
                    label="name"
                    :multiple="false"
                    :allowEmpty="!!allowEmpty"
                    :reset-after="true"
                    placeholder="Acciones en lote"
                    selectedLabel=""
                    selectLabel=""
                    deselectLabel=""
                    @select="dispatchAction">
                </multiselect>
            </b-col>
        </b-row>
        
        <b-modal
            ref="chargeDateModal"
            hide-footer
            size="sm"
            title="Cobrar Recibo">
            <b-container class="py-2">
                <b-row>
                    <b-col>
                        <b-form-group
                            label="<strong>Fecha de cargo</strong>">
                            <v-date-picker
                                id="chargeDate"
                                v-model="chargeDate"
                                class="p-0 date-picker-w-100 date-picker-custom-border"></v-date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col col class="d-flex flex-row-reverse">
                        <div>
                            <button
                                class="btn btn-secondary btn-md"
                                @click="closeChargeDateModal(true)">
                                Aceptar
                            </button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>

    </b-container>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import { setupCalendar, DatePicker } from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: "ConsignmentOverviewActionsSelector",
        components: {
            Multiselect,
            'v-date-picker': DatePicker,
        },
        props: {
            extraOptions: Boolean,
            allowEmpty: Boolean,
            allowEmpty: Boolean,
            receipts: Array,
            selectedReceipts: Array,
            receiptDeletePermission: Boolean,
            blockDeleteReceipt: Boolean | String,
        },
        data: function () {
            return {
                defaultValue: null,
                actions: [
                    { name: 'Seleccionar todos', $isDisabled: ( this.receipts.length == 0 ) },
                    { name: 'Deseleccionar todos', $isDisabled: true },
                    { name: 'Eliminar', $isDisabled: true },
                ],
                chargeDate: null
            }
        },
        methods: {
            dispatchAction (action) {
                if(action.name === 'Cobrar sin llamar') {
                    this.showChargeDateModal();
                } else {
                    this.$emit('selected-action', { action: action.name });
                }
            },
            showChargeDateModal() {
                this.$refs.chargeDateModal.show();
            },
            closeChargeDateModal(emit = null) {
                if (emit) {
                    this.$refs.chargeDateModal.hide();
                    this.$emit('selected-action', { action: 'Cobrar sin llamar', value: this.chargeDate });
                } else {
                    this.$refs.chargeDateModal.hide();
                }
            }
        },
        watch: {
            receipts: function() {
                this.actions[0].$isDisabled = ( this.receipts.length == 0 );
            },
            selectedReceipts: function() {
                this.actions[1].$isDisabled = ( this.selectedReceipts.length == 0 );
                this.actions[2].$isDisabled = ( this.selectedReceipts.length == 0 );
                this.actions[3].$isDisabled = ( this.selectedReceipts.length == 0 );
                const actionDelete = this.actions.find(action => action.name === 'Eliminar');
                actionDelete['$isDisabled'] = this.blockDeleteReceipt || !( this.selectedReceipts.length > 0 && this.receiptDeletePermission );
            }
        },
        created() {
            this.chargeDate = null;
            if (this.extraOptions) {
                this.actions.splice(2,0, { name: 'Cobrar sin llamar', $isDisabled: true });
                this.actions.splice(3,0, { name: 'Anular / Condonar', $isDisabled: true });
            }
        },
    }
</script>

<style scoped>
    .btn-calendar {
        cursor: pointer !important;
    }
</style>
